export default __webpack_public_path__ + "static/media/regulatory--dual-lanes-bicyclists-and-pedestrians--g1.b3dad17b.png";